module.exports = __webpack_public_path__ + "static/media/Christmas_4.ba6653e9.jpg";